import React,{useState} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Tools} from './Tools';
import {Styles} from './Styles';
import Loading from './Loading';
import FourMeters from './FourMeters';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
    gold(num:number):void,
}

let selectedIndex = 0;
let up = 0;

const EventEmpty = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        found: false,
        selected: false,
        finished: false,
        isLoading: false,
    })
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }
    const search = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                if( res.found ){
                    up = res.play.gold-props.play.gold;
                    props.gold(up);
                }
                setStates({...states,newPlay:res.play,found:res.found,isLoading:false,selected:true});
            }
        })
    }

    if( states.selected ){
        let mes = "ベッドに座って少し休んだ";
        if( states.found ){
            mes = Inc.coinFroms[ props.play.turn%6 ] + "プラスチックのコインを"+up+"枚見つけた";
        } else if( selectedIndex===1 ){
            mes = "この部屋では何もみつからなかった";
        }
    
        return (
            <div id="event_empty">
                <div className={classes.room}>
                    呼吸をするたびにのどが渇いていく<br/>
                    {mes}<br/>
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close} style={{width:"100%"}}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
            </div>
        );    
    }

    let mes = "この部屋にはベッドしかない";

    return (
        <div id="event_empty">
            {props.play.turn===1 ? (
            <div className={classes.room}>
                白い壁とベッドしかない部屋だ<br/>
                ドアは少し開いている<br/>
                窓の外は明るすぎて何も見えない<br/>
                空気はとても乾いている
            </div>
            ):(
                <div className={classes.room}>
                {mes}
                {props.param.selected===0 &&
                    <div>かすかに{props.play.lover_flower}の香りがする</div>
                }
                {props.param.selected===1 &&
                    <div>ベッドのあたりを{Tools.lover(props.play,props.param)}が調べた形跡がある</div>
                }
            </div>
            )}

            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <Button variant="contained" color="primary" onClick={search} data-index={1} style={{marginBottom:"0.2em"}}>ベッドを調べる</Button>
                    <Button variant="outlined" color="primary" onClick={search} data-index={0} style={{marginBottom:"0.2em"}}>何もしない</Button>
                </FormControl>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventEmpty;
